<template>
  <header class="app-header">
    <div class="app-information">
      <div class="p-d-flex p-jc-between p-ai-center">
        <div class="p-mr-5 p-as-start">
          <router-link to="/">
            <img
              id="logo"
              src="img/logo.svg"
              alt="Oudoor Vision"
              height="70"
            >
          </router-link>
        </div>
        <h2 class="title">
          Devenez <span>l'expert</span> de votre territoire
        </h2>
        <div
          v-if="canUseApp"
          class="p-mr-2"
        >
          <div
            id="login"
            class="p-d-flex p-ai-center"
          >
            <div class="p-mr-2">
              <a
                v-if="canKeygest"
                :href="keygest"
              >
                <Button
                  v-tooltip.left="'Administration'"
                  icon="pi pi-users"
                  class="p-button-secondary p-button-rounded"
                />
              </a>
            </div>
            <div class="p-mr-2">
              <Button
                v-if="$keycloak.authenticated"
                v-tooltip.left="`Se déconnecter (${user})`"
                class="p-button-rounded"
                icon="pi pi-sign-out"
                @click="$keycloak.logoutFn"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="p-d-flex p-jc-center">
        <TabMenu
          v-if="canUseApp"
          :model="items"
        />
      </div>
    </div>
  </header>
</template>

<script>
import TabMenu from 'primevue/tabmenu';
import Button from 'primevue/button';
import { containsAudience } from '@/utils/helpers';

export default {
  components: { TabMenu, Button },
  data () {
    return {
      keygest: process.env.VUE_APP_KEYGEST,
      items: [
        { label: 'Accueil', icon: 'pi pi-fw pi-home', to: '/' },
        { label: 'Vue générale', to: '/MapF1' },
        { label: 'Emprise géographique', to: '/MapF3' },
        { label: 'Itinéraire défini', to: '/MapF4' },
        { label: 'Départs / Arrivées', to: '/MapF5' },
        { label: 'Comparaison temporelle', to: '/MapF6Diff' },
        { label: 'Répartition des activités', to: '/MapF7' },
        { label: 'Zones de pauses', to: '/MapF8' },
      ],
    };
  },

  computed: {
    canKeygest () {
      const { aud = [] } = this.$keycloak.tokenParsed || {};
      return containsAudience(aud, process.env.VUE_APP_KEYGEST_AUD);
    },

    canUseApp () {
      const { aud = [] } = this.$keycloak.tokenParsed || {};
      return containsAudience(aud, process.env.VUE_APP_API_AUD);
    },

    user () {
      return this.$keycloak.tokenParsed.preferred_username;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.p-tabmenu) {
  .p-highlight > a {
    border-color: #312b6c !important;
    background: #e7e6fc !important;
  }
  .p-tabmenuitem > a:hover {
    border-color: #312b6c !important;
  }
  .p-menuitem-text {
      color: #312b6c;
      font-weight: 500;
      font-size: 1rem;
  }
  .p-menuitem-icon {
    color: #312b6c;
  }
}
</style>

<style scoped>

.app-header {
  box-shadow: 0 8px 6px -6px #ccc;
}

.title {
  color: #96bb37;
  text-transform: uppercase;
  margin: 1rem auto 0.5rem auto;
}

.title span {
  color: #302c69;
}

.app-information {
  margin: 0 1em 0 1em;
}

#login {
  margin-right: 4em;
}

@media screen and (max-width: 600px) {
  #logo {
    margin: 0 auto;
  }
  #version-id {
    width: 100%;
  }
  .baseline {
    width: 100%;
    text-align: center;
  }
  .full-width {
    width: unset;
  }
}
</style>
